import { classNames } from '~/utils/client/helpers'
import { useClientEnv } from '~/utils/client/hooks/useClientEnv'
import { LanguageSelector } from '../ui/LanguageSelector'
import { i18n } from '@lingui/core'

interface FooterProps {
  centered?: boolean
  className?: string
  maxScreen?: string
}

export const Footer = ({ centered = false, className, maxScreen }: FooterProps) => {
  const publicEnv = useClientEnv()
  const centeredClassName = centered ? 'text-center' : ''
  const innerStyle = classNames(maxScreen ?? 'max-w-screen-lg', 'mx-auto')

  const year = new Date().getFullYear()

  return (
    <footer
      className={classNames(
        'bg-white py-2 border-border-default border-t',
        centeredClassName,
        className
      )}
    >
      <div className={classNames(innerStyle, 'px-4 sm:px-6 md:px-10 2xl:px-0 flex-1')}>
        <div className="flex flex-row justify-between">
          <div className="flex flex-col sm:flex-row sm:justify-between sm:items-center space-y-2 sm:space-y-0">
            <div className="flex flex-col space-y-1">
              <span className="text-sm leading-6 text-body hover:text-accent">
                &copy; {year} Baumann & Partner S.A.
              </span>
              <div className="flex flex-wrap gap-x-2">
                <a
                  href="https://bpvv.lu/de/impressum/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm leading-6 text-body hover:text-accent focus-ring-brand"
                >
                  {i18n._('Impressum')}
                </a>{' '}
                |{' '}
                <a
                  href="https://bpvv.lu/de/datenschutz/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm leading-6 text-body hover:text-accent focus-ring-brand"
                >
                  {i18n._('Datenschutz')}
                </a>{' '}
                {/* |{' '}
                <Link
                  to="https://bpam.lu/de/kontakt-de"
                  className="text-sm leading-6 text-body hover:text-accent"
                >
                  {i18n._('Kontakt')}
                </Link> */}
              </div>
              <span className="text-xs leading-6 text-body hidden sm:block">
                {publicEnv.buildTag}
              </span>
            </div>

            <span className="text-xs leading-6 text-body sm:hidden">{publicEnv.buildTag}</span>
          </div>
          <div className="flex items-center pl-10">
            <LanguageSelector />
          </div>
        </div>
      </div>
    </footer>
  )
}
